import { useStore } from 'ra-core';
import { SavedQuery } from './types';

function isValidSavedQuery(savedQuery: unknown): savedQuery is SavedQuery {
  if (!savedQuery || typeof savedQuery !== 'object') {
    return false;
  }

  const query = savedQuery as SavedQuery;
  return (
    typeof query.label === 'string' &&
    Boolean(query.value) &&
    typeof query.value.displayedFilters === 'object' &&
    typeof query.value.perPage === 'number' &&
    typeof query.value.sort?.field === 'string' &&
    typeof query.value.sort?.order === 'string' &&
    typeof query.value.filter === 'object'
  );
}

function extractValidSavedQueries(queries: SavedQuery[]): SavedQuery[] {
  if (!Array.isArray(queries)) {
    return [];
  }
  return queries.filter(isValidSavedQuery);
}

function useSavedQueries(resource: string): [SavedQuery[], (queries: SavedQuery[]) => void] {
  return useStore<SavedQuery[]>(`${resource}.savedQueries`, []);
}

export { extractValidSavedQueries, useSavedQueries };
